const _ = require('lodash')

const REGEXP_URL_STRING = /http.?:\/\/[\w/:%#$&?~.=+-]+/g

/**
 * テンプレート置換文字が含まれていないかチェックする.
 * @param value チェック対象となる文字列.
 * Returns 文字列にテンプレート置換文字が含まれていたら true それ以外は false.
 */
function isTemplateReplacementCharacters (value) {
  if (_.isString(value)) {
    return /●●【|】●●/.test(value)
  }
  return false
}

/**
 * IPアドレス形式かチェックする
 * @param value チェック対象となる文字列
 * Returns IPアドレス形式であれば true それ以外は false.
 */
function isIpAddressFormat (value) {
  if (_.isString(value)) {
    return /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(value)
  }
  return false
}

/**
 * 選考リマインドメールの本文の[map:面接場所]をリンクに置換する
 * @param  value チェック対象となる文字列
 * @returns
 */
function replaceMapLink (value) {
  // 検索対象の文字列を掲出する正規表現([map:から]の前まで抽出)
  const regexSearchPlace = /(\[map:)(.*)(?=])/g
  // 置換対象文字列を抽出する正規表現([map:任意の文字列]を抽出)
  const regexTarget = /(\[map:.*])/g
  const place = value.match(regexSearchPlace)

  // 場所にURLが入力されていた場合表示しないUSERの仕様に合わせる
  const containsUrl = includeUrl(place)
  if (containsUrl) {
    return value.replace(regexTarget, match => {
      return ''
    })
  }

  // 場所が存在する場合googleMap表示の変換
  if (place) {
    // [map:から掲出されるため、sliceで5文字目以降を取り出す
    const url = `https://maps.google.co.jp/?q=${place.toString().slice(5)}`
    return value.replace(regexTarget, match => {
      return `<a href="${encodeURI(url)}" target="_blank">[map]</a>`
    })
  }
  return value
}

function objectFilter (obj, filterFunction) {
  // objectではない場合、空オブジェクトを返却
  if (obj === null || typeof obj !== 'object') return {}

  // objectのvalueに対してフィルタをかける
  return Object.keys(obj)
    .filter(function (key) {
      return filterFunction(obj[key])
    })
    .reduce(function (result, key) {
      result[key] = obj[key]
      return result
    }, {})
}

/**
 * URLが含まれているかチェックする
 * @param {*} value URLが含まれている可能性のある文字列
 * @returns true:含まれる/false含まれない
 */
const includeUrl = (value) => {
  return REGEXP_URL_STRING.test(value)
}

/**
 * URLが含まれている場合にaタグで囲む
 * @param value URLが含まれている可能性のある文字列
 * Returns URLをaタグで変換した文字列
 */
const replaceUrlLink = (value) => {
  return value.replace(REGEXP_URL_STRING, match => `<a href="${match}" target="_blank">${match}</a>`)
}

/**
 * アドレスが含まれている場合にaタグで囲む
 * @param value アドレスが含まれている可能性のある文字列
 * Returns アドレスをaタグで変換した文字列
 */
const replaceAddressLink = (value) => {
  return value.replace(/[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*/gi, match => `<a href="mailto:${match}" target="_blank">${match}</a>`)
}

const replaceAddressAndUrlLink = (value) => {
  return replaceAddressLink(replaceUrlLink(value))
}

exports.isTemplateReplacementCharacters = isTemplateReplacementCharacters
exports.isIpAddressFormat = isIpAddressFormat
exports.objectFilter = objectFilter
exports.replaceAddressAndUrlLink = replaceAddressAndUrlLink
exports.replaceMapLink = replaceMapLink
exports.includeUrl = includeUrl
